<template>
  <div id="footer">
    <p>© Node Hill AB</p>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";

@Component()
export default class SearchArticles extends Vue {
  get isOnSearchPage() {
    return ["home", "adminArticles"].includes(this.$route.name);
  }

  mounted() {
    let options = {
      root: null,
      rootMargin: '100px 0px',
      threshold: 0
    }

    let observer = new IntersectionObserver(this.intersected, options);
    let target = document.querySelector('#footer');
    observer.observe(target);
  }

  intersected(entries) {
    if(this.isOnSearchPage && !this.$store.state.article.isFetching) {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          this.$store.commit('nextPage')

          setTimeout(() => {
            this.$store.commit('loadNextPage')
          }, 50);
        } 
      });
    }
  }

}
</script>


<style scoped>
#footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 50px;
  background-color: #eee;
  border-top: 1px solid #ccc;
}
p {
  margin-top: 8px;
}
</style>
